import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import type { Language } from '~/resources/graphql/graphql'

export function useSelectedLanguage() {
    const { locale } = useI18n({ useScope: 'global' })

    return computed<Language>(() => {
        // Keep the GraphQL language enum aligned with the active storefront locale.
        if (locale.value.startsWith('es-MX')) {
            return 'SPANISH_MX'
        }

        if (locale.value.startsWith('fr')) {
            return 'FRENCH'
        }

        if (locale.value.startsWith('de')) {
            return 'GERMAN'
        }

        return 'ENGLISH'
    })
}
